<template>
  <div id="app">
    <header>
      <p id="site_name">
        <router-link :to="{ name: 'home' }">
          UCC FOODS Smile Festa 2019 バーチャルビュー
        </router-link>
      </p>
      <button type="button" class="drawer-toggle drawer-hamburger">
        <span class="sr-only">toggle navigation</span>
        <span class="drawer-hamburger-icon"></span>
      </button>
      <Navigation />
    </header>

    <router-view />

    <div id="copy_wrap" class="clearfix">
      <p id="copyrights">
        Copyrights &copy; UCC FOODS Co, Ltd. All Rights Reserved.
      </p>
      <p id="ucc_logo">
        <span>
          <img
            src="@/assets/images/common/logo_ucc.png"
            width="60px"
            alt="ucc"
          />
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import Navigation from './components/Navigation.vue';

export default {
  name: 'app',
  components: {
    Navigation
  },
  mounted: function() {
    require('@/assets/js/j_easing.min.js');
    require('@/assets/js/iscroll.js');
    require('@/assets/js/drawer.min.js');
    require('@/assets/js/jquery.fademover.js');
    require('@/assets/js/mov.js');
  }
};
</script>

<style>
.mov {
  width: 560px;
  height: 315px;
}
</style>
